export default __webpack_public_path__ + "static/media/companies-benefits-01-9.d14e3e43.svg";